<fa-icon
   [fixedWidth]="true"
   [icon]="isStatusOk ? healthyIcon : errorIcon"
   [class.isHealthy]="isStatusOk"
   [class.isInError]="!isStatusOk"
>
</fa-icon>
